<template>
  <b-row>
    <b-col lg="12">
      <div
        id="container"
        class="d-flex justify-content-end"
      >
        <svg
          :width="isSmallScreen() ? '100%' : '580px'"
          :height="isSmallScreen() ? '100%' : '100%'"
          viewBox="0 0 713 955"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.7719 161L673.789 160.602H687.162H711V141.735V70.8162V64.6769V9H649.764H349.15H292.382H39.4662H4V31.5288V140.683V161H26.7719Z"
            fill="#000E10"
            fill-opacity="0.8"
          />
          <path
            d="M26.7719 677L673.789 675.669H687.162H711V612.616V375.596V355.078V169H649.764H349.15H292.382H39.4662H4V244.294V609.098V677H26.7719Z"
            fill="#000E10"
            fill-opacity="0.8"
          />
          <path
            d="M24.8363 954.486L673.684 953.766H687.095H711V919.697V791.629V780.543V680H649.591H348.126H291.197H37.5665H2V720.683V917.797V954.486H24.8363Z"
            fill="#000E10"
            fill-opacity="0.8"
          />

          <!-- ปริมาณจราจรแต่ละ Phase (วัน) -->
          <foreignObject
            width="50%"
            height="100%"
            x="0"
            y="10"
          >
            <div>
              <svg
                width="579"
                height="154"
                viewBox="0 0 579 154"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M257.324 118.184H312.551H545V23H30.9529L31.8077 95.7745V118.184H257.324Z"
                    fill="url(#paint0_linear_130_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_130_2)">
                  <path
                    d="M543.571 123.184C546.332 123.184 548.571 120.945 548.571 118.184C548.571 115.422 546.332 113.184 543.571 113.184V123.184ZM30 123.184H543.571V113.184H30V123.184Z"
                    fill="url(#paint1_linear_130_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_130_2)"
                >
                  <path
                    d="M36.429 25.7661C36.4013 23.0048 34.1405 20.7887 31.3792 20.8164C28.6179 20.844 26.4018 23.1049 26.4295 25.8662L36.429 25.7661ZM26.4295 25.8662L27.3823 121.05L37.3818 120.95L36.429 25.7661L26.4295 25.8662Z"
                    fill="#00FF40"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_130_2"
                    x="0"
                    y="83.1839"
                    width="578.571"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_130_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_130_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_130_2"
                    x="6.4292"
                    y="0.816101"
                    width="50.9526"
                    height="140.234"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.25 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_130_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_130_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_130_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_130_2"
                    x1="545.014"
                    y1="105.071"
                    x2="31.8057"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_130_2"
                    x1="30"
                    y1="118.684"
                    x2="543.571"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="55"
                  y="40"
                >
                  <b-img
                    :src="require('@/assets/images/icons/cartotal.svg')"
                    style="height: 60px; width: 60px; margin-top: -13px"
                  />&nbsp;
                  <span style="font-size: 34px;">ปริมาณยานพาหนะทั้งหมด (วันนี้)</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <foreignObject
            x="50"
            y="95"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span
              style="text-align:left; font-weight: 700; font-size:40px; color: #46E0E5; text-shadow: 0 0 6px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
            >
              {{ Total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน/วัน
            </span>
          </foreignObject>

          <foreignObject
            width="50%"
            height="100%"
            x="360"
            y="10"
          >
            <div>
              <svg
                width="579"
                height="154"
                viewBox="0 0 579 154"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.2">
                  <path
                    d="M257.324 118.184H312.551H545V23H30.9529L31.8077 95.7745V118.184H257.324Z"
                    fill="url(#paint0_linear_130_2)"
                    fill-opacity="0.5"
                  />
                </g>
                <g filter="url(#filter0_d_130_2)">
                  <path
                    d="M543.571 123.184C546.332 123.184 548.571 120.945 548.571 118.184C548.571 115.422 546.332 113.184 543.571 113.184V123.184ZM30 123.184H543.571V113.184H30V123.184Z"
                    fill="url(#paint1_linear_130_2)"
                  />
                </g>
                <g
                  id="bolt1"
                  filter="url(#filter1_df_130_2)"
                >
                  <path
                    d="M36.429 25.7661C36.4013 23.0048 34.1405 20.7887 31.3792 20.8164C28.6179 20.844 26.4018 23.1049 26.4295 25.8662L36.429 25.7661ZM26.4295 25.8662L27.3823 121.05L37.3818 120.95L36.429 25.7661L26.4295 25.8662Z"
                    fill="#FF8000"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_130_2"
                    x="0"
                    y="83.1839"
                    width="578.571"
                    height="70"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="15" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.183437 0 0 0 0 0.340519 0 0 0 0 0.375 0 0 0 0.49 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_130_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_130_2"
                      result="shape"
                    />
                  </filter>
                  <filter
                    id="filter1_df_130_2"
                    x="6.4292"
                    y="0.816101"
                    width="50.9526"
                    height="140.234"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite
                      in2="hardAlpha"
                      operator="out"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.616667 0 0 0 0 0 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_130_2"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_130_2"
                      result="shape"
                    />
                    <feGaussianBlur
                      stdDeviation="2.5"
                      result="effect2_foregroundBlur_130_2"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_130_2"
                    x1="545.014"
                    y1="105.071"
                    x2="31.8057"
                    y2="105.071"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop
                      offset="0.0810585"
                      stop-color="#000506"
                    />
                    <stop
                      offset="0.1876"
                      stop-color="#001416"
                    />
                    <stop
                      offset="0.3084"
                      stop-color="#205274"
                    />
                    <stop
                      offset="0.4397"
                      stop-color="#27628A"
                    />
                    <stop
                      offset="0.5795"
                      stop-color="#3585BB"
                    />
                    <stop
                      offset="0.724"
                      stop-color="#00A0C3"
                    />
                    <stop
                      offset="0.8554"
                      stop-color="#00B3FF"
                    />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_130_2"
                    x1="30"
                    y1="118.684"
                    x2="543.571"
                    y2="118.684"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#0D6E89" />
                    <stop
                      offset="0.421"
                      stop-color="#2A929C"
                      stop-opacity="0.5"
                    />
                    <stop
                      offset="0.681"
                      stop-color="#1C6269"
                      stop-opacity="0.2"
                    />
                    <stop
                      offset="1"
                      stop-color="#2F5760"
                      stop-opacity="0.15"
                    />
                  </linearGradient>
                </defs>
                <foreignObject
                  width="100%"
                  height="100%"
                  x="80"
                  y="40"
                >
                  <b-img
                    :src="require('@/assets/images/icons/carpcu.svg')"
                    style="height: 60px; width: 60px; margin-top: -13px"
                  />&nbsp;
                  <span style="font-size: 32px;">PCU (วันนี้)</span>
                </foreignObject>
              </svg>
            </div>
          </foreignObject>

          <foreignObject
            x="400"
            y="95"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span
              style="text-align:left; font-weight: 700; font-size:40px; color: #46E0E5; text-shadow: 0 0 6px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
            >
              {{ Total_PCU }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              PCU
            </span>
          </foreignObject>

          <!-- TrafficSciFiGaugePhase -->
          <foreignObject
            id="bolt1"
            width="100%"
            height="100%"
            x="0"
            y="190"
          >
            <div>
              <CountingSciFiGaugePhase />
            </div>
          </foreignObject>

          <!-- ปริมาณจราจรแต่ละ Phase (วัน) -->
          <foreignObject
            width="100%"
            height="100%"
            x="30"
            y="180"
          >
            <b-img
              :src="require('@/assets/images/icons/avg.svg')"
              style="height: 40px; width: 40px; margin-top: -13px"
            />&nbsp;
            <span style="font-size: 24px;">Average Speed</span>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="240"
            y="185"
          >
            <feather-icon
              id="popover-average"
              icon="AlertCircleIcon"
              size="22"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-average"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/avergespeed.jpeg"
              />
            </b-popover>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="280"
            y="185"
          >
            <feather-icon
              v-b-modal="'TotalFormula'"
              icon="TwitchIcon"
              size="30"
              :style="{ color: 'rgb(201, 255, 0, 1)'}"
            />
            <ModalTotalFormula ref="" />
          </foreignObject>

          <foreignObject
            width="100%"
            height="100%"
            x="400"
            y="180"
          >
            <b-img
              :src="require('@/assets/images/icons/85per1.svg')"
              style="height: 40px; width: 40px; margin-top: -13px"
            />&nbsp;
            <span style="font-size: 24px;">85th Percentile Speed
            </span>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="680"
            y="185"
          >
            <feather-icon
              id="popover-Percentile"
              icon="AlertCircleIcon"
              size="22"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-Percentile"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/th85.jpeg"
                fluid
              />
            </b-popover>
          </foreignObject>

          <!-- TrafficLog -->
          <!-- <foreignObject
            id=""
            width="95%"
            height="100%"
            x="20"
            y="362"
          >
            <div>
              <CountingStatistic />
            </div>
          </foreignObject> -->

          <foreignObject
            id=""
            width="93%"
            height="100%"
            x="40"
            y="380"
          >
            <div id="boltX1">
              <CountingSciFiTable />
            </div>
          </foreignObject>
          <!-- TrafficPhase -->
          <foreignObject
            id=""
            width="87%"
            height="100%"
            x="40"
            y="665"
          >
            <div>
              <CountingSciPhase />
            </div>
          </foreignObject>

          <foreignObject
            width="100%"
            height="4%"
            x="620"
            y="345"
          >
            <div
              v-b-modal="'TableDetailFormula'"
              style="color: #46E0E5;"
            >
              <span style="text-decoration: underline; font-size: 14px;">ดูเพิ่มเติ่ม</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="24"
              />
            </div>
            <ModalTableFormula ref="" />
          </foreignObject>

          <foreignObject
            width="100%"
            height="100%"
            x="660"
            y="690"
          >
            <feather-icon
              v-b-modal="'LiveAnalytic'"
              icon="CameraIcon"
              size="20"
              :style="{ color: 'rgb(255, 174, 0, 1)'}"
              @click="$refs.cam.getRTSPCCTV()"
            />&nbsp;
            <Modalcam ref="cam" />
          </foreignObject>
        </svg>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BImg, VBModal, BPopover,
} from 'bootstrap-vue'
// import CountingLogMore from '@/views/countingscifi1/detailfi2/CountingLogMore.vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import CountingSciPhase from '@/views/countingscifi1/detailfi2/CountingSciPhase.vue'
// import CountingStatistic from '@/views/countingscifi1/detailfi2/CountingStatistic.vue'
import CountingSciFiGaugePhase from '@/views/countingscifi1/detailfi2/CountingSciFiGaugePhase.vue'
import Modalcam from '@/views/countingscifi1/detailfi2/Modalcam.vue'
import ModalTotalFormula from '@/views/countingscifi1/detailfi2/ModalTotalFormula.vue'
import ModalTableFormula from '@/views/countingscifi1/detailfi2/ModalTableFormula.vue'

import CountingSciFiTable from '@/views/countingscifi1/detailfi2/CountingSciFiTable.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,
    BImg,
    BPopover,
    Modalcam,
    ModalTotalFormula,
    ModalTableFormula,

    CountingSciPhase,
    CountingSciFiGaugePhase,
    CountingSciFiTable,
    // CountingStatistic,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      // animate: false,
      iconColor: 'rgba(0, 228, 255, 0.5)',
      Total: '',
      Total_PCU: '',
      Bike: '',
      Truck: '',
      Car: '',
      Bus: '',
      Taxi: '',
      Pickup: '',
      Trailer: '',
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    this.getSumCount()
    this.getSumCountPCU()
    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {
    getSumCount() {
      axios
        .post('/getSumCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.Total = response.data[0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Bike = response.data[0].Bike.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getSumCountPCU() {
      axios
        .post('/getTotalPCU', { wid: this.$route.query.wid })
        .then(response => {
          this.Total_PCU = response.data[0].Total_PCU.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },
    // toggleAnimation() {
    //   this.animate = !this.animate
    // },
    isSmallScreen() {
      return window.innerWidth <= 850
    },
  },
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

#container {
  // height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
svg {
  max-width: 100%;
  height: auto;
  background: none; /* Ensures no background color */
  fill: rgba(0, 7, 33, 0.573); /* Prevents fill patterns from having unwanted backgrounds */
}

#svg3 {
  justify-content: center;
  align-items: center;

  // --grey: rgb(255, 87, 51, 1.0);
  --magenta: url(#paint0_linear_368_286);

  // width: 150px;
  stroke: var(--magenta);
  fill: var(--grey);
  stroke-dasharray: 400;
  stroke-dashoffset: 54;
  stroke-linejoin: round;
  stroke-linecap: round;
  transform-origin: center;
  animation: 2s ease-in-out infinite fadeStrokeright1;
  // stroke: rgb(48, 181, 235);

@keyframes fadeStrokeright1 {
    0%, 100% {
      stroke-width: 8;
    }
    60% {
      stroke-width: 12;
    }
    // 100% {
    //   stroke-width: 8;
    // }
    20% {
      stroke-width: 6;
    }
  }
}

#bolt1 {
   animation: dropInY1 6s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInY1 {
    0% {
      opacity: 0;
      transform: translateY(-100%);
    }
    30%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
#boltX1 {
   animation: dropInX1 10s ease forwards;
   animation-delay: 200ms;

   @keyframes dropInX1 {
    0% {
      opacity: 0;
      transform: translateZ(-100%);
    }
    100% {
      opacity: 1;
      transform: translateZ(0);
    }
  }
}
</style>
